import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import IconClose from 'components/icons/iconClose';
const STORE_TYPE_PARTNER = 2;
const StoreLink = t0 => {
  const $ = _c(6);
  const {
    storeData,
    isPartner: t1
  } = t0;
  const isPartner = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== storeData.slug) {
    t2 = storeData.slug?.replace(/^\/+|\/+$/g, "")?.replace(/^showrooms\//, "") || "";
    $[0] = storeData.slug;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const slug = t2;
  const showroomUrl = slug ? `/showrooms/${slug}/` : "/showrooms/";
  const t3 = `underline hover:no-underline !font-bold ${isPartner ? "text-gray" : "text-brand"}`;
  let t4;
  if ($[2] !== showroomUrl || $[3] !== storeData.name || $[4] !== t3) {
    t4 = <div className="text-sm ml-2"><Link to={showroomUrl} className={t3}>{storeData.name}</Link></div>;
    $[2] = showroomUrl;
    $[3] = storeData.name;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
const StoreSection = t0 => {
  const $ = _c(20);
  const {
    title,
    stores,
    isPartner: t1
  } = t0;
  const isPartner = t1 === undefined ? false : t1;
  const [isExpanded, setIsExpanded] = useState(false);
  if (stores.length === 0) {
    return null;
  }
  const hasMultiple = stores.length > 1;
  const additionalCount = stores.length - 1;
  let t2;
  if ($[0] !== isExpanded || $[1] !== stores) {
    t2 = isExpanded ? stores : stores.slice(0, 1);
    $[0] = isExpanded;
    $[1] = stores;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const storesToShow = t2;
  const t3 = isPartner ? "mt-3" : "";
  let t4;
  if ($[3] !== title) {
    t4 = <div className="text-sm text-gray mb-1">{title}:</div>;
    $[3] = title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== isPartner || $[6] !== storesToShow) {
    let t6;
    if ($[8] !== isPartner) {
      t6 = store => <StoreLink key={store.storeData.id} {...store} isPartner={isPartner} />;
      $[8] = isPartner;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    t5 = storesToShow.map(t6);
    $[5] = isPartner;
    $[6] = storesToShow;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[10] !== additionalCount || $[11] !== hasMultiple || $[12] !== isExpanded || $[13] !== isPartner) {
    t6 = hasMultiple && !isExpanded && <button type="button" onClick={() => setIsExpanded(true)} data-xc={isPartner ? "ShowroomLocatorPartnerStudiosMore" : "ShowroomLocatorShowroomsMore"} className={`text-sm underline hover:no-underline mt-1 ml-2 !font-bold ${isPartner ? "text-gray" : "text-brand"}`}>+ {additionalCount} more</button>;
    $[10] = additionalCount;
    $[11] = hasMultiple;
    $[12] = isExpanded;
    $[13] = isPartner;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t4 || $[17] !== t5 || $[18] !== t6) {
    t7 = <div className={t3}>{t4}{t5}{t6}</div>;
    $[15] = t3;
    $[16] = t4;
    $[17] = t5;
    $[18] = t6;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  return t7;
};
StoreSection.propTypes = {
  title: PropTypes.string.isRequired,
  stores: PropTypes.array.isRequired,
  isPartner: PropTypes.bool
};
StoreSection.defaultProps = {
  isPartner: false
};
const ShowroomLocatorResults = t0 => {
  const $ = _c(32);
  const {
    loading,
    error,
    stores,
    onClose,
    isMobile
  } = t0;
  if (loading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="text-sm text-gray mt-2">Searching...</div>;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (error) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <div className="mt-2"><div className="text-sm text-red mb-2">Error searching for showroom. Please try again.</div></div>;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  let showrooms;
  let t1;
  if ($[2] !== stores) {
    const validStores = stores.filter(_temp);
    showrooms = validStores.filter(_temp2);
    t1 = validStores.filter(_temp3);
    $[2] = stores;
    $[3] = showrooms;
    $[4] = t1;
  } else {
    showrooms = $[3];
    t1 = $[4];
  }
  const partnerStudios = t1;
  const hasAnyResults = showrooms.length > 0 || partnerStudios.length > 0;
  if (hasAnyResults) {
    const t2 = `mt-2 ${isMobile ? "" : "pt-2 [border-top:1px_solid_#f1f1f1]"}`;
    let t3;
    if ($[5] !== showrooms) {
      t3 = <StoreSection title="Showrooms" stores={showrooms} />;
      $[5] = showrooms;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] !== partnerStudios) {
      t4 = <StoreSection title="Partner Studios" stores={partnerStudios} isPartner={true} />;
      $[7] = partnerStudios;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    let t5;
    if ($[9] !== t3 || $[10] !== t4) {
      t5 = <div className="flex-1">{t3}{t4}</div>;
      $[9] = t3;
      $[10] = t4;
      $[11] = t5;
    } else {
      t5 = $[11];
    }
    let t6;
    if ($[12] !== isMobile || $[13] !== onClose) {
      t6 = !isMobile && onClose && <button type="button" data-xc="FooterShowroomCloseResults" onClick={onClose} className="text-gray pt-2 pr-1" aria-label="Close results"><IconClose width={10} height={10} /></button>;
      $[12] = isMobile;
      $[13] = onClose;
      $[14] = t6;
    } else {
      t6 = $[14];
    }
    let t7;
    if ($[15] !== t5 || $[16] !== t6) {
      t7 = <div className="flex justify-between items-start">{t5}{t6}</div>;
      $[15] = t5;
      $[16] = t6;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    let t8;
    if ($[18] !== t2 || $[19] !== t7) {
      t8 = <div data-xc="FooterShowroomResults" className={t2}>{t7}</div>;
      $[18] = t2;
      $[19] = t7;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    return t8;
  }
  const t2 = `mt-2 ${isMobile ? "" : "pt-2 border-t border-t-gray-light5"}`;
  let t3;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="text-sm text-gray mb-2">Showroom results:</div>;
    $[21] = t3;
  } else {
    t3 = $[21];
  }
  let t4;
  if ($[22] !== isMobile || $[23] !== onClose) {
    t4 = !isMobile && onClose && <button type="button" onClick={onClose} className="text-gray pt-2 pr-1" aria-label="Close results"><IconClose width={10} height={10} /></button>;
    $[22] = isMobile;
    $[23] = onClose;
    $[24] = t4;
  } else {
    t4 = $[24];
  }
  let t5;
  if ($[25] !== t4) {
    t5 = <div className="flex justify-between items-start">{t3}{t4}</div>;
    $[25] = t4;
    $[26] = t5;
  } else {
    t5 = $[26];
  }
  let t6;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="text-sm font-bold mb-2 pl-2">Nearest Joybird Showroom or Partner Studio:{" "}<Link to="/showrooms/#showrooms-google-map" className="text-brand underline">Map</Link></div>;
    $[27] = t6;
  } else {
    t6 = $[27];
  }
  let t7;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="text-sm text-gray pl-2">Try our{" "}<Link to="/showrooms/virtual/" data-xc="ShowroomLocatorVirtualShowroomLink" className="text-brand underline">Virtual Showroom</Link></div>;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  let t8;
  if ($[29] !== t2 || $[30] !== t5) {
    t8 = <div data-xc="FooterShowroomResults" className={t2}>{t5}{t6}{t7}</div>;
    $[29] = t2;
    $[30] = t5;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  return t8;
};
ShowroomLocatorResults.propTypes = {
  loading: PropTypes.bool.isRequired,
  error: PropTypes.object,
  stores: PropTypes.array,
  onClose: PropTypes.func,
  isMobile: PropTypes.bool
};
ShowroomLocatorResults.defaultProps = {
  stores: [],
  onClose: null,
  isMobile: false
};
export default ShowroomLocatorResults;
function _temp(store) {
  return store.storeData;
}
function _temp2(store_0) {
  return store_0.storeData.type !== STORE_TYPE_PARTNER;
}
function _temp3(store_1) {
  return store_1.storeData.type === STORE_TYPE_PARTNER;
}